import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import TodayPanel from './TodayPanel';

type TodayPanelFullscreenProps = {
  onClose: () => void;
};

export default function TodayPanelFullscreen({ onClose }: TodayPanelFullscreenProps) {
  return createPortal(
    <div
      className="fixed inset-0 z-[25000] flex flex-col bg-slate-900/40 backdrop-blur-[2px] p-3 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Follow-ups"
    >
      <div className="mx-auto flex h-full w-full max-w-[420px] flex-col overflow-hidden rounded-[12px] border border-[rgba(28,28,26,0.1)] bg-white shadow-[0_16px_40px_rgba(28,28,26,0.12)]">
        <TodayPanel layout="fullscreen" onClose={onClose} className="fu-fullscreen h-full" />
      </div>
      <button
        type="button"
        className="fixed end-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/95 text-slate-600 shadow-lg hover:bg-white sm:end-6 sm:top-6"
        onClick={onClose}
        aria-label="Close"
      >
        <FiX className="h-5 w-5" />
      </button>
    </div>,
    document.body,
  );
}
